import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-to-top',
    templateUrl: './to-top.component.html',
    styleUrl: './to-top.component.css',
    standalone: false,
})
export class ToTopComponent {
    @Output() onTopEmit = new EventEmitter<void>();

    onTop() {
        this.onTopEmit.emit();
    }
}
